import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/Layout";
import { useParams, useNavigate } from "react-router-dom";
import styled from "@emotion/styled";

import { listmailInbox } from "../features/mail/mailSlice";
import { useSelector, useDispatch } from "react-redux";
import TableInbox from "../components/TableInbox/TableInbox";
import { theme } from "../utils/theme";
import Button from "../components/Button/Button";
import CopyToClipboard from "../components/CopyToClipboard/CopyToClipboard";

const Wrapper = styled("div")`
  margin-top: 2rem;
`;

const Table = styled("table")`
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  margin-top: 2rem;

  tbody {
    color: ${theme.colors.secondary};
  }

  td,
  th {
    border: 1px solid #ddd;
    padding: 8px;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  tr:hover {
    background-color: #ddd;
  }

  th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: ${theme.colors.primary};
    color: white;
  }
`;

const InboxScreen = () => {
  const [copyText, setCopyText] = useState("");
  let params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { listinboxmail } = useSelector((state) => state.mail);

  useEffect(() => {
    dispatch(listmailInbox(params.mail));
  }, [dispatch, params]);

  if (!listinboxmail) {
    return <div>Loading State...</div>;
  }

  const backHandler = () => {
    navigate(-1);
  };

  const refreshHandle = () => {
    dispatch(listmailInbox(params.mail));
  };

  return (
    <Layout>
      <Wrapper>
        <Button onClickHandle={backHandler} value="Back" />
        <CopyToClipboard copyText={params.mail} refreshBtn={refreshHandle} />
        <Table>
          <thead>
            <tr>
              <th>From</th>
              <th>Subject</th>
              <th>Date & Time</th>
            </tr>
          </thead>
          <tbody>
            {listinboxmail
              ? listinboxmail.map((item) => {
                  return (
                    item.payload.headers[
                      item.payload.headers.findIndex(
                        (x) => x.name === "Delivered-To"
                      )
                    ].value === params.mail && <TableInbox item={item} />
                  );
                })
              : null}
          </tbody>
        </Table>
      </Wrapper>
    </Layout>
  );
};

export default InboxScreen;
